import { render, staticRenderFns } from "./Specializations.vue?vue&type=template&id=45d504c8&scoped=true&"
import script from "./Specializations.js?vue&type=script&lang=js&"
export * from "./Specializations.js?vue&type=script&lang=js&"
import style0 from "./Specializations.scss?vue&type=style&index=0&id=45d504c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d504c8",
  null
  
)

export default component.exports